import type { AccordionToken, Theme } from 'hephaestus/core';
import { merge } from 'lodash-es';

export const useAccordionTokens = (theme: Theme): AccordionToken => {
  const { color, borderRadius, component } = theme;
  const base = {
    borderRadius: borderRadius.xl,
    borderColor: color.outline,
    multipleBorderColor: color.outlineVariant,
    progressBar: {
      supportColors: {
        activeSupportColorOne: color.supportOneNew,
        activeSupportColorTwo: color.supportTwo,
        activeSupportColorThree: color.supportThree,
        activeSupportColorFour: color.supportFour,
        activeSupportColorFive: color.supportFive,
        activeSupportColorSix: color.supportSix,
        inactiveSupportColorOne: color.supportOneNewVariant,
        inactiveSupportColorTwo: color.supportTwoVariant,
        inactiveSupportColorThree: color.supportThreeVariant,
        inactiveSupportColorFour: color.supportFourVariant,
        inactiveSupportColorFive: color.supportFiveVariant,
        inactiveSupportColorSix: color.supportSixVariant,
      },
      supportPositiveColors: {
        activeSupportColorOne: '#162456',
        activeSupportColorTwo: '#004D7F',
        activeSupportColorThree: '#00779E',
        activeSupportColorFour: '#03A1B3',
        activeSupportColorFive: '#5DCBC2',
        activeSupportColorSix: '#A4F4CF',
        inactiveSupportColorOne: '#7082DB',
        inactiveSupportColorTwo: '#66BFFF',
        inactiveSupportColorThree: '#80DBFF',
        inactiveSupportColorFour: '#99F5FF',
        inactiveSupportColorFive: '#D6F5EF',
        inactiveSupportColorSix: '#D2F9E6',
      },
      supportNegativeColors: {
        activeSupportColorOne: '#66001E',
        activeSupportColorTwo: '#BB3D0C',
        activeSupportColorThree: '#D46600',
        activeSupportColorFour: '#E78D00',
        activeSupportColorFive: '#F6B600',
        activeSupportColorSix: '#FFDF20',
        inactiveSupportColorOne: '#FF4D82',
        inactiveSupportColorTwo: '#FAC7B2',
        inactiveSupportColorThree: '#FFE5CC',
        inactiveSupportColorFour: '#FFEBCC',
        inactiveSupportColorFive: '#FFF1CC',
        inactiveSupportColorSix: '#FFF7CC',
      },
    },
  };

  return merge({}, base, component?.accordion) as AccordionToken;
};
